import { useEffect, useRef, useState } from "react";
import BellIcon from "components/icons-svg/BellIcon";
import { markAuthStore, selectIsArriveFromHomePage } from "stores/auth/authSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { selectSwitchPriceDrop } from "stores/price-drop/priceDropSlice";
import { selectSearch } from "stores/search/searchSlice";
import { getCookie } from "utils/cookies";
import { useOnClickOutside } from "utils/hooks/useOnClickOutside";
interface TooltipMessageProps {
  message?: string;
  className?: string;
  isShowTooltip?: boolean;
}
const DateTooltipMessage = ({
  message = "Now click “Set a Price Drop Alert”",
  className = ""
}: TooltipMessageProps) => {
  const dispatch = useAppDispatch();
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const isArriveFromHomePage = useAppSelector(selectIsArriveFromHomePage);
  const switchPriceDrop = useAppSelector(selectSwitchPriceDrop);
  const search = useAppSelector(selectSearch);
  const isGoogle = getCookie("isGoogle") === "true";
  // Show tooltip when user arrives from home page and has selected a date range and not switched to price drop
  useEffect(() => {
    if (!switchPriceDrop && isArriveFromHomePage && search?.startDate && search?.endDate) {
      setShowTooltip(true);
      dispatch(markAuthStore({
        isArriveFromHomePage: false
      }));
    } else if (switchPriceDrop) {
      setShowTooltip(false);
    }
  }, [isGoogle, dispatch, isArriveFromHomePage, search?.startDate, search?.endDate, switchPriceDrop]);
  useOnClickOutside(tooltipRef, () => setShowTooltip(false), "mouseup");
  return showTooltip && <div ref={tooltipRef} className={`absolute right-[20px] top-[-175%] w-[275px] rounded-lg bg-[#003C49] px-2 py-4 shadow-[0_4px_35px_0_rgba(55,56,77,0.70)] min-[350px]:w-[310px] ssm2:w-[370px]
          min-[429px]:p-4 md:bottom-auto md:top-[115%] lg2:-left-1/2 lg2:right-[initial] ${className}`}>
        <div className='flex items-center gap-2 whitespace-pre-line text-xs font-medium leading-[19.6px] text-white min-[350px]:text-sm xsm:gap-4 lg:text-base lg:leading-[22px]'>
          <BellIcon className='h-[16px] w-[14px] fill-transparent stroke-[#008292] stroke-[1.5] lg:h-5 lg:w-[17px]' />
          {message}
        </div>

        {/* Tooltip Arrow */}
        {/* On mobile: arrow points DOWN (since tooltip is above) */}
        <div className={`absolute -bottom-[7px] right-[20px] top-auto border-l-[6px]
            border-r-[6px] border-t-[7px] border-l-transparent border-r-transparent border-t-[#003C49] md:bottom-auto md:top-[-7px] md:-translate-x-1/2
            md:border-b-[7px] md:border-t-0 md:border-b-[#003C49] lg2:left-1/2 lg2:right-[initial]`} />
      </div>;
};
export default DateTooltipMessage;